interface InlineStatusMessageProps {
  children: React.ReactNode;
  'data-testid'?: string;
}

export function InlineStatusMessage({
  children,
  'data-testid': dataTestid,
}: InlineStatusMessageProps) {
  return (
    <div
      className="border-white-40 grid min-h-[98px] w-full grid-cols-1 items-center rounded-md border"
      data-testid={dataTestid}
    >
      <div className="text-grey-60 h-full px-4 py-6 text-center">
        {children}
      </div>
    </div>
  );
}
